import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { AI_CHAT_CONFIGURATIONS_ACTION_TYPE } from '../actions';

const initialState = {
  configurations: [],
  templates: [],
};

const aiChatConfigurationsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case AI_CHAT_CONFIGURATIONS_ACTION_TYPE.GET_AI_CHAT_CONFIGURATIONS:
        draft.configurations = payload;
        break;

      case AI_CHAT_CONFIGURATIONS_ACTION_TYPE.GET_AI_CHAT_CONFIGURATION_BY_ID:
        draft.configurations = state.configurations.some(
          configuration => configuration.id === payload.id,
        )
          ? state.configurations.map(configuration =>
              configuration.id === payload.id ? payload : configuration,
            )
          : [...state.configurations, payload];
        break;

      case AI_CHAT_CONFIGURATIONS_ACTION_TYPE.UPDATE_AI_CHAT_CONFIGURATION:
        draft.configurations = state.configurations.map(configuration =>
          configuration.id === payload.id ? payload : configuration,
        );
        break;

      case AI_CHAT_CONFIGURATIONS_ACTION_TYPE.CREATE_AI_CHAT_CONFIGURATION:
        draft.configurations = [...state.configurations, payload];
        break;

      case AI_CHAT_CONFIGURATIONS_ACTION_TYPE.DELETE_AI_CHAT_CONFIGURATION:
        draft.configurations = state.configurations.filter(({ id }) => id !== payload);
        break;

      case AI_CHAT_CONFIGURATIONS_ACTION_TYPE.GET_TEMPLATES:
        draft.templates = payload;
        break;

      case AI_CHAT_CONFIGURATIONS_ACTION_TYPE.ENABLE_TEMPLATE:
        draft.templates = state.templates.map(template =>
          template.id === payload ? { ...template, isEnabled: true } : template,
        );
        break;

      case AI_CHAT_CONFIGURATIONS_ACTION_TYPE.DISABLE_TEMPLATE:
        draft.templates = state.templates.map(template =>
          template.id === payload ? { ...template, isEnabled: false } : template,
        );
        break;

      case AI_CHAT_CONFIGURATIONS_ACTION_TYPE.CLONE_TEMPLATE:
        draft.configurations = [...state.configurations, payload];
        break;

      case AI_CHAT_CONFIGURATIONS_ACTION_TYPE.RESET_AI_CHAT_CONFIGURATIONS_STATE:
      case RESET_STATE:
        return initialState;

      default:
        break;
    }
  });

export default aiChatConfigurationsReducer;
